import React from "react";
import { ProtectedPageContext } from "../pages/_contexts/ProtectedPageContext";
import { Card } from "./Card";
import { Flex } from "./compositeComponents/FlexHelpers";
import { PropsWithChildren } from 'react';
import styled from "styled-components";


type ActionCardProps = {
    header: string,
    style?: React.CSSProperties
}

export function ActionCard(props: PropsWithChildren<ActionCardProps>): JSX.Element
{
    const ctx = React.useContext(ProtectedPageContext);

    return (
        // width and minWidt are important to make that content inside the card can shrink and not overflow the card when the card is in a flex container with other cards
        <Card variant="outlined" style={{ padding: '12px 16px', width: '100%', minWidth: 0, ...props.style }}>
            <Flex flexDirection="column" gap={8} style={{ width: '100%', minWidth: 0 }}>
                <div style={{ fontSize:'14px', color: ctx.colors.text.state.info }}>{props.header}</div>
                <div style={{ width: '100%', minWidth: 0 }}>{props.children}</div>
            </Flex>
        </Card>
    );
}

type ActionCardContainerProps = {
    minCardWidth?: string,
    gap?: number,
    style?: React.CSSProperties
}

export function ActionCardContainer(props: PropsWithChildren<ActionCardContainerProps>): JSX.Element
{
    return (
        <ActionCardGrid
            minCardWidth={props.minCardWidth}
            gap={props.gap}
            style={props.style}
        >
            {props.children}
        </ActionCardGrid>
    );
}

const ActionCardGrid = styled.div<{ minCardWidth?: string, gap?: number }>`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${props => props.minCardWidth || '280px'}, 1fr));
    gap: ${props => `${props.gap ?? 16}px`};
    width: 100%;
`;